import { PlusIcon } from "@heroicons/react/24/solid";
import { MinusIcon } from "@heroicons/react/24/solid";
import React, { useEffect, useState } from "react";

export default function Counter({
  startValue = 0,
  minValue = 0,
  maxValue = Infinity,
  onCountChange,
}: {
  startValue?: number;
  minValue?: number;
  maxValue?: number;
  onCountChange: (value: number) => void;
}) {
  const [count, setCount] = useState<number>(startValue);

  useEffect(() => {
    setCount(startValue);
  }, [startValue]);

  const handleIncrement = () => {
    if (count < maxValue) {
      const newValue = count + 1;
      setCount(newValue);
      onCountChange(newValue); // Call the handler with new value
    }
  };

  const handleDecrement = () => {
    if (count > minValue) {
      const newValue = count - 1;
      setCount(newValue);
      onCountChange(newValue); // Call the handler with new value
    }
  };

  return (
    <div className="flex flex-row">
      <div className="flex flex-col">
        <button
          className="font-semibold px-2 py-2 shadow-lg bg-electrum text-white hover:bg-electrum-300 focus:bg-electrum-focus focus:outline-none disabled:bg-gray-400 disabled:cursor-not-allowed rounded-l-md"
          onClick={handleDecrement}
          disabled={count <= minValue}
        >
          <MinusIcon className="w-4 h-4" />
        </button>
      </div>
      <input
        className="w-12 h-8 px-2 py-2 border-2 border-electrum text-center shadow-lg focus:outline-none focus:border-[#00A3E0] disabled:cursor-not-allowed"
        type="number"
        value={count}
        readOnly
      />
      <div className="flex flex-col">
        <button
          className="font-semibold px-2 py-2 shadow-lg bg-electrum text-white hover:bg-electrum-300 focus:bg-electrum-focus focus:outline-none disabled:bg-gray-400 disabled:cursor-not-allowed rounded-r-md"
          onClick={handleIncrement}
          disabled={count >= maxValue}
        >
          <PlusIcon className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}

// Define default props
Counter.defaultProps = {
  onCountChange: () => {},
};
